<template>
	<div :style="{ width: `${size}px` }">
		<canvas ref="chartCanvas"></canvas>
	</div>
</template>

<script>
import Chart from 'chart.js';

export default {
	props: {
		chartValue: {
			type: Number,
			required: true
		},
		labelChartA: {
			type: Number,
			default: 0,
			required: false
		},
		labelChartB: {
			type: Number,
			default: 0,
			required: false
		},
		size: {
			type: Number,
			default: 180
		},
		chartColorA: {
			type: String,
			default: '#00a0af'
		},
		chartColorB: {
			type: String,
			default: '#285f74'
		}
	},
	data() {
		return {
			chart: null,
			valueAText: `${100 - this.chartValue}%`,
			valueBText: `${this.chartValue}%`
		};
	},
	watch: {
		data(dataValue) {
			if (dataValue) {
				this.drawChart();
			}
		}
	},
	mounted() {
		this.drawChart();
	},
	beforeDestroy() {
		if (this.chart) {
			this.chart.destroy();
		}
	},
	methods: {
		drawChart() {
			if (this.chart) {
				this.chart.destroy();
			}
			const ctx = this.$refs.chartCanvas.getContext('2d');
			const charValueB = 100 - this.chartValue;
			new Chart(ctx, {
				type: 'doughnut',
				data: {
					labels: ['Value A', 'Value B'],
					datasets: [
						{
							data: [this.chartValue, charValueB],
							backgroundColor: [this.chartColorA, this.chartColorB]
						}
					]
				},
				options: {
					legend: {
						display: false
					},
					responsive: true,
					tooltips: {
						callbacks: {
							label: tooltipItem => {
								const dataIndex = tooltipItem.index;
								if (dataIndex === 0) {
									return this.labelChartA;
								} else if (dataIndex === 1) {
									return this.labelChartB;
								}
								return '';
							}
						},
						titleFontSize: 22,
						bodyFontSize: 18,
						bodyFontColor: '#687682',
						backgroundColor: '#fff',
						borderColor: '#ddd',
						borderWidth: 1
					}
				}
			});
		}
	}
};
</script>
<style lang="scss" scoped></style>
